import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";

const RedirectSessionProvider = () => {
  useEffect(() => {
    const session = localStorage.getItem("redirectSession");
    if (session) {
      try {
        const { token, baseUrl, dbNumber } = JSON.parse(session);
        if (token && baseUrl && dbNumber !== undefined) {
          const url = !baseUrl.endsWith("/") ? `${baseUrl}/` : baseUrl;
          window.location.href = `${url}login-callback?token=${token}&db_number=${dbNumber}`;
        }
      } catch (error) {
        console.error("Erro ao ler redirectSession do localStorage", error);
      }
    }
  }, []);

  return <Outlet />;
};

export default RedirectSessionProvider;
